import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import womanPhoneMedication from '../../common/images/womanPhoneMedication.png';
import appUi from '../../common/images/appUi.png';
import googlePlay from '../../common/images/googlePlay.png';
import appStore from '../../common/images/appStore.png';
import './index.scss';
import { bannerNameValueFunc } from '../../common/utils';
import { appDownloadLinks, bannerObj } from '../../common/consts';
import { gtmDataObject, pageTitleData } from '../../common/gtmconsts';
import { DataLayerFunction } from '../../common/dataLayerFunction';
import Header from '../../layout/Header/HeaderLogo';

function ImzDeprecationPage() {
  const navigate = useNavigate();
  const banner = bannerNameValueFunc();
  const bannerName =
    bannerObj.find((item) => item.bannerName === banner)?.heroText || '';
  const downloadLink = appDownloadLinks?.[banner] || '';

  useEffect(() => {
    const childPath = window.location.pathname.split('/')[2];
    if (childPath) {
      navigate('/');
    } else {
      sendAnalytics();
    }
  }, []);

  return (
    <>
      <Header />
      <div className="deprecation-container p-md-5">
        <div className="row align-items-center">
          <div className="col-md-6 text-center">
            <img src={womanPhoneMedication} alt="" className="pe-3 pe-md-0" />
          </div>
          <div className="col-md-6">
            <h3>We’ve made it easy</h3>
            <p>
              You’ll now get paper coupons for 10% off groceries when you get
              immunized at the pharmacy. No need to worry about clipping your
              immunization coupons in the app!
            </p>
          </div>
        </div>
        <div className="row align-items-center mt-4">
          <div className="col-md-6 order-md-2 text-center">
            <img src={appUi} alt="" className="appUiImage" width="100%" />
          </div>
          <div className="col-md-6 order-md-1">
            <h3>More ways to save</h3>
            <p>
              Download the {bannerName} app and create a pharmacy profile to
              unlock new savings opportunities.
            </p>
            <DownloadLinks
              downloadLink={downloadLink}
              manageDisplay={'d-none d-md-flex justify-content-start ml-20px'}
            />
          </div>
        </div>
        <DownloadLinks
          downloadLink={downloadLink}
          manageDisplay={'d-flex d-md-none justify-content-center'}
        />
      </div>
    </>
  );
}

export default ImzDeprecationPage;

function DownloadLinks({ downloadLink, manageDisplay }) {
  return (
    <div className={`${manageDisplay} gap-4 mt-4`}>
      <a href={downloadLink} target="_blank" rel="noopener noreferrer">
        <img src={appStore} alt="Download from App Store" />
      </a>
      <a href={downloadLink} target="_blank" rel="noopener noreferrer">
        <img src={googlePlay} alt="Download from Google Play" />
      </a>
    </div>
  );
}

function sendAnalytics() {
  const subSection1 = 'Imz Deprecation Page';
  DataLayerFunction(
    pageTitleData.VerificationIMZ,
    pageTitleData.Verification,
    gtmDataObject.Verification,
    subSection1,
  );
}

DownloadLinks.propTypes = {
  downloadLink: PropTypes.string.isRequired,
  manageDisplay: PropTypes.string.isRequired,
};
